import * as Application from 'expo-application';
import { randomUUID as uuidv4 } from 'expo-crypto';

import { isAndroid, isIos } from 'utils/environment';
import { SyncStorageKey, syncStorage } from 'utils/environment/sync-storage';

// get from syncstorage if it exists there since this is fastest
let deviceId = syncStorage.getString(SyncStorageKey.DEVICE_ID);

// normal way to get deviceId except for certain circumstances
export const getDeviceId = () => deviceId;

// might be async on the first time app is ever started on iOS, we use syncstorage afterwards
export const getDeviceIdAsync = async (): Promise<string> => {
  if (deviceId) {
    return deviceId;
  }

  if (isIos) {
    // this read can take up to 1 second on ios (not sure why...) so we avoid it if at all possible with syncstorage read instead
    const iosId = await Application.getIosIdForVendorAsync();
    deviceId = iosId || '';
  } else if (isAndroid) {
    const androidId = Application.getAndroidId();
    deviceId = androidId || '';
  } else {
    // expo removed support from this for web so keep it the same as it was in prior SDK versions
    const KEY_NAME = 'EXPO_CONSTANTS_INSTALLATION_ID';

    const id = localStorage.getItem(KEY_NAME);
    if (id) {
      deviceId = id;
    } else {
      const uuid = uuidv4();
      localStorage.setItem(KEY_NAME, uuid);
      deviceId = uuid;
    }
  }
  deviceId = deviceId.toLowerCase();
  syncStorage.setString(SyncStorageKey.DEVICE_ID, deviceId);
  return deviceId;
};

// get this as soon as possible and make all ios code wait for one call to it since it has been observed to take 1s to come back!
// noop outside of iOS
getDeviceIdAsync();
